import { createContext } from "preact";
import ApiClient from "../api";

export const Api = createContext<ApiClient>(new ApiClient());

export const MapBoxKey = createContext<string>("");
